module.exports = __webpack_public_path__ + "files/d022a2c4934fdc803f7532b82addeb60.png";